import { BouLinkExternal } from '@upright/ui/common/generic/content/texts/bou-link';
import Icon from '@upright/ui/icons/img/streamline-mini-line/interface-essential/arrows/interface-arrows-expand-5.svg';
import styled from 'styled-components';

export interface TooltipReadMoreLinkProps {
  href: string;
  target?: string;
  text?: string;
  onClick?: () => void;
}

export function TooltipReadMoreLink(props: TooltipReadMoreLinkProps) {
  return (
    <Root href={props.href} target={props.target === undefined ? 'blank' : props.target} onClick={props.onClick}>
      <LinkText>{props.text || 'Read more'}</LinkText>
      <Icon style={{ height: '0.8em', width: '0.8m', marginLeft: '0.5em', stroke: 'currentColor' }} />
    </Root>
  );
}

const Root = styled(BouLinkExternal)`
  display: block;
  margin-top: 0.5em;
  font-weight: 600;
  text-decoration: none;
  justify-content: flex-start;
  > div,
  > svg {
    min-width: 0 !important;
  }
`;

const LinkText = styled.span``;
